export default {
  links: [
    {
      path: "/app/clients",
      label: "Personal Info"
    },
    // {
    //   path: "/app/clients/company_info",
    //   label: "Company Info"
    // },
    // {
    //   path: "/app/clients/business_info",
    //   label: "Business Info"
    // },
    // {
    //   path: "/app/clients/doc_upload",
    //   label: "Doc Upload"
    // }
  ],
  columns: [
    {
      title: "Client Name",
      dataIndex: "user_name",
      hasFilter: true
    },
    {
      title: "Client ID",
      dataIndex: "user_id",
    },
    {
      title: "Email ID",
      dataIndex: "email_address",
    },
    {
      title: "Mobile No.",
      dataIndex: "contact_number",
      sorter: (a, b) => a.mobileNumber - b.mobileNumber,
      hasFilter: true
    },
    {
      title: "Join Date",
      dataIndex: "createdAt",
      render: (text, record) => (text || "").date().moment().format("DD MMM YYYY"),
    },
    {
      title: "Entity Name",
      dataIndex: "company_name",
      sorter: (a, b) => a.companyName - b.companyName,
      hasFilter: true,
    },
    {
      title: "Location",
      dataIndex: "location",
    }
  ],
  fields(arr, excludes = []) {
    return this.columns.map((obj) => ({
      ...Object.except(obj, ['dataIndex', 'hasFilter', 'className']),
      name: obj.dataIndex,
      label: obj.title || obj.dataIndex.toTitleCase(),
      required: true,
      ...(arr.find(o => o.name == obj.dataIndex) ? arr.find(o => o.name == obj.dataIndex) : {})
    })).filter(o => !excludes.includes(o.name));
  }
}